import { useState, useEffect } from 'react'
import { useIssueLogs } from 'api/hooks/use-issue-logs'
import { useDebounce } from 'api/hooks/use-debounce'
import LogCard from './LogCard'
import TableFooter from 'shared/tables/table-footer'
import { Card, Form, InputGroup, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

function IssueLogs({ issueId, params, setParams }) {
  const {
    data: issueLogs,
    isSuccess,
    isLoading
  } = useIssueLogs({ issueId, params, options: { keepPreviousData: true } })

  const [searchInput, setSearchInput] = useState(params.search || '')
  const debouncedSearch = useDebounce(searchInput, 500)

  useEffect(() => {
    setParams((prev) => (
      (prev.search || '') === debouncedSearch ? prev : { ...prev, search: debouncedSearch, page: 1 }
    ))
  }, [debouncedSearch, setParams])

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    setParams({
      ...params,
      search: searchInput,
      page: 1
    })
  }

  const handleSearchClear = () => {
    setSearchInput('')
    setParams({
      ...params,
      search: '',
      page: 1
    })
  }

  return (
    <>
      <div>
        {isSuccess && (
          <>
            <h5 className="mb-3">Issue Log</h5>
            <Card className="shadow-sm mb-3">
              <Card.Body className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <Form onSubmit={handleSearchSubmit} className="d-flex">
                    <InputGroup style={{ flexWrap: 'nowrap' }}>
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          placeholder="Search logs by details..."
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          style={{ width: '250px', paddingRight: searchInput ? '30px' : undefined, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                        />
                        {searchInput && (
                          <span
                            onClick={handleSearchClear}
                            style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', zIndex: 10 }}
                          >
                            <FontAwesomeIcon icon={faTimes} className="text-muted" />
                          </span>
                        )}
                      </div>
                      <Button variant="light" type="submit">
                        <FontAwesomeIcon icon={faSearch} className="text-primary" />
                      </Button>
                    </InputGroup>
                  </Form>
                  <Form.Select
                    value={params.log_status}
                    onChange={(e) => setParams({ ...params, log_status: e.target.value, page: 1 })}
                  >
                    <option value="">All Logs</option>
                    <option value="unresolved">Unresolved</option>
                    <option value="resolved">Resolved</option>
                    <option value="ignored">Ignored</option>
                  </Form.Select>
                </div>
                <Form.Select
                  value={params.orderDirection}
                  onChange={(e) => setParams({ ...params, orderDirection: e.target.value, page: 1 })}
                  style={{ width: 'auto' }}
                >
                  <option value="desc">Newest First</option>
                  <option value="asc">Oldest First</option>
                </Form.Select>
              </Card.Body>
            </Card>
            <ul className="list-group">
              {issueLogs.data.map((logItem) => (
                <LogCard log={logItem} key={logItem.id} />
              ))}
              {issueLogs.data.length === 0 && (
                <li className="list-group-item text-muted py-4">
                  No logs available
                </li>
              )}
            </ul>
          </>
        )}
        {isLoading && (
          <div className="text-center">
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
      <div className="mt-3 px-3">
        {isSuccess && (
          <TableFooter
            meta={issueLogs.meta}
            params={params}
            setParams={setParams}
          />
        )}
      </div>
    </>
  )
}

export default IssueLogs
